// export fn to avoid mocking createElement
/* istanbul ignore next */
export function exportExcelByDocument(url: string, fileName: string) {
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.xlsx`; // Name of the file
  a.click();
}
